var React = require('react');

function FeatureTerrainPark (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(0.000000, -38.000000)","fill":"#F36C22","fillRule":"nonzero"},React.createElement("rect",{"x":"0","y":"38","width":"33","height":"17","rx":"8.5"}))));
}

FeatureTerrainPark.defaultProps = {"role":"presentation","viewBox":"0 0 33 17","version":"1.1"};

module.exports = FeatureTerrainPark;

FeatureTerrainPark.default = FeatureTerrainPark;
